import type { QueryInfo } from './types';
import type { GraphQLResolveInfo } from 'graphql';

export const isQueryInfo = (
  infoOrFieldNode: QueryInfo | GraphQLResolveInfo,
): infoOrFieldNode is QueryInfo => {
  return Boolean((infoOrFieldNode as QueryInfo)?.field);
};
